import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-view-patient-history',
  templateUrl: './view-patient-history.component.html',
  styleUrls: ['./view-patient-history.component.scss']
})
export class ViewPatientHistoryComponent implements OnInit {
  patientInfo: any = [];

  constructor(
    private dialogRef: MatDialogRef<ViewPatientHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService: CommonService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    // console.log(this.data);
    this.getToxPatientHistory();
  }

  getToxPatientHistory() {
    this.commonService.getToxPatientHistory(this.data.patientId).subscribe(res => {
      if (res && res.data) {
        this.patientInfo = res.data;
      }
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
